import { createTheme } from "@mui/material/styles";
// Enables theme default props for the x-date-pickers components (MuiTimePicker, MuiDateTimePicker, ...)
import type {} from "@mui/x-date-pickers/themeAugmentation";

// Show every minute in the time picker clock instead of MUI's default 5-minute step.
const allMinutesTimeSteps = { hours: 1, minutes: 1, seconds: 1 };

export const theme = createTheme({
    typography: {
        fontFamily: "Inter, sans-serif",
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiTimePicker: {
            defaultProps: {
                timeSteps: allMinutesTimeSteps,
            },
        },
        MuiDateTimePicker: {
            defaultProps: {
                timeSteps: allMinutesTimeSteps,
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: "Inter, sans-serif !important",
                },
            },
        },
    },
});